/**
 * Created by 唐亦慧 on 2018/2/6.
 */
import React from 'react';
import Reflux from 'reflux';
import {
  Layout,
  Table,
  Checkbox,
  Modal,
  message,
  InputNumber,
} from 'antd';
import {
  productActions,
  productStore,
} from '../mallHome/store';
import {
  hashHistory,
  withRouter,
} from 'react-router';
import '../mallApp.css';
import {
  changeNum,
  deleteShoppingCarList,
  getShoppingCarList,
} from '../../service/shoppingCar';
import {
  addFavoritesList,
  deleteFavoritesList,
} from '../../service/product';
import {
  openNotice,
  returnFloat,
  config,
} from 'Utils';
import {
  getOrderList,
  getOrderList2,
} from '../../service/order';

const confirm = Modal.confirm;
const { Header } = Layout;

class MallCart extends Reflux.Component {
  constructor(props) {
    super(props);
    this.store = Reflux.initStore(productStore);
    this.userData = JSON.parse(window.localStorage.getItem('login_user_information') || '{}');
    this.channelData = window.sessionStorage.getItem('cur_channel') || '{}';
    this.state = {
      dataSource: [],
      mainHeight: window.document.body.clientHeight - 64 - 128 - 132 + 'px',
      selectedRowKeys: [],
      allMoney: 0,
      allMinus: 0,
      inputKey: null,
      zeroAdd: true,
      isShow: true,
      total: 0,
      allProduct: 0,
      keyword: this.store.state.searchMallData.keyword, //关键字
      productSelected: [],//默认选中
      orderLength: 0, //订单
      orderSearchObj: {
        code: '',
        productCode: '',
        orderStatus: '',
        orderType: '',
        gatherRealityAddress: '',
        channelCode: this.channelData.split('|')[1] || '',
        getProCode: '',
        customerOrderCode: '',
        startCreatedDate: '',
        endCreatedDate: '',
        buyCompanyId: '',
        remark: '',
        specialOfferCode: '',
        s: 10,
        p: 1,
      },
    };
    this.goView = this.goView.bind(this);
    this.deleteProduct = this.deleteProduct.bind(this);
    this.resize = this.resize.bind(this);
    this.onSelectChange = this.onSelectChange.bind(this);
    this.checkBox = this.checkBox.bind(this);
    this.deleteAll = this.deleteAll.bind(this);
    this.getCartCount = this.getCartCount.bind(this);
    this.routeLeaveHook = this.routeLeaveHook.bind(this);
  }

  componentDidMount() {
    window.onresize = this.resize;
    this.getCartCount();
    if(this.userData.second) {
      // trans/order/list
      getOrderList2({p: 1, s: 10}).then(result => {
        if (result && result.code == 200) {
          this.setState({
            'orderLength': result.total,
          });
        } else {
          openNotice('error', '数据获取失败', '');
        }
      })
    } else {
      getOrderList(this.state.orderSearchObj).then((result) => {
        if (result && result.code == 200) {
          this.setState({
            'orderLength': result.total,
          });
        } else {
          openNotice('error', '数据获取失败', '');
        }
      });
    }
    this.props.router.setRouteLeaveHook(this.props.route, this.routeLeaveHook);
  }

  //离开当前路由时
  routeLeaveHook(nextLocation) {
    let path = nextLocation.pathname.split('/');
    if (!(path[1] === 'mallPay' && path[2] === 'settleAccounts')) {
      window.localStorage.removeItem('buyAgain');
    }
  }

  //获取购物车商品
  getCartCount() {
    return new Promise((resolve, reject) => {
      const params = {
        userId: this.userData.id,
        name: '',
        category: [],
        active: '',
        s: 10,
        p: 1,
        channelCode: this.channelData.split('|')[1] || '',
      };
      getShoppingCarList(params).then((result) => {
        if (result.status && result.data.productList) {
          var newList = result.data.productList;
          var newSelected = [];
          if (newList.length > 0) {
            for (var n = 0; n < newList.length; n++) {
              if (newList[n].minimumPacking > newList[n].minimumOrderQuantity) {
                newList[n].newQuantity = newList[n].minimumPacking;
              } else {
                if (newList[n].minimumOrderQuantity % newList[n].minimumPacking == 0) {
                  newList[n].newQuantity = newList[n].minimumOrderQuantity;
                } else {
                  newList[n].newQuantity = (parseInt((newList[n].minimumOrderQuantity / newList[n].minimumPacking), 10) - 0 + 1) * newList[n].minimumPacking;
                }
              }
              if (this.state.productSelected.indexOf(newList[n].id) !== -1) {
                newSelected.push(newList[n].id);
              }
            }
          }
          this.setState({
            dataSource: newList,
            selectedRowKeys: newSelected,
          });
          resolve(newSelected);
        } else {
          if (!result.status) message.error(result.message);
        }
      });
    });
  }

  onSelectChange(selectedRowKeys) {
    const { dataSource } = this.state;
    let money = 0;
    let allCount = 0;
    dataSource.forEach(x => {
      if (selectedRowKeys.includes(x.id)) {
        money += (x.totalAmount || 0);
        allCount += (x.count || 0);
      }
    });
    this.setState({
      selectedRowKeys,
      total: returnFloat(money),
      allMoney: returnFloat(money),
      allProduct: allCount,
    });
  }

  resize() {
    this.setState({ mainHeight: window.document.body.clientHeight - 64 - 128 - 132 + 'px' });
  }

  //页面跳转
  goView(url) {
    hashHistory.push(url);
  }

  //点击表格下方全选
  checkBox(e) {
    const { dataSource } = this.state;
    var newData = [];
    if (e.target.checked) {
      for (var d = 0; d < dataSource.length; d++) {
        newData.push(dataSource[d].id);
      }
      this.onSelectChange(newData);
    } else {
      this.onSelectChange([]);
    }
  }

  setCollection({ commodityId, productId, isCollection }) {
    if (isCollection === 1) {
      deleteFavoritesList([{ productId, commodityId }]).then(res => {
        res.status && this.getCartCount();
        openNotice(res.status ? 'success' : 'error', res.message || '');
      });
    } else {
      addFavoritesList([{ productId, commodityId }]).then(res => {
        res.status && this.getCartCount();
        openNotice(res.status ? 'success' : 'error', res.message || '');
      });
    }
  }

  //删除
  deleteProduct(index, id) {
    var self = this;
    var selectedRowKeys = this.state.selectedRowKeys;
    confirm({
      title: '确定删除?',
      okText: '确定',
      cancelText: '取消',
      onOk() {
        deleteShoppingCarList({ ids: [id] }).then((result) => {
          if (result && result.status) {
            message.success(result.message);
            self.getCartCount().then(() => {
              selectedRowKeys.splice(index, 1);
              self.setState({
                selectedRowKeys,
              });
              self.onSelectChange(selectedRowKeys);
            });
          } else {
            message.error(result.message);
          }
        });
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  }

  //批量删除
  deleteAll() {
    var self = this;
    if (this.state.selectedRowKeys.length > 0) {
      confirm({
        title: '确定删除所选?',
        //content: 'Some descriptions',
        okText: '确定',
        okType: 'danger',
        cancelText: '取消',
        onOk() {
          deleteShoppingCarList({ ids: self.state.selectedRowKeys }).then((result) => {
            if (result && result.status) {
              message.success(result.message);
              self.getCartCount().then(() => {
                self.setState({
                  selectedRowKeys: [],
                });
                self.onSelectChange([]);
              });
            } else {
              message.error(result.message);
            }
          });
        },
        onCancel() {
          console.log('Cancel');
        },
      });
    } else {
      message.info('未选择商品');
    }
  }

  /*数量加减*/
  changeNumber = (record, index, value) => {
    changeNum({ id: record.id, count: value }).then(result => {
      result.status && this.getCartCount();
      console.log(result);
    });
  };

  //去结算
  goPay() {
    const { dataSource, selectedRowKeys } = this.state;
    if (selectedRowKeys.length > 0) {
      let list = [];
      list = dataSource.filter(x => selectedRowKeys.includes(x.id));
      for (let i = 0; i < list.length; i++) {
        if(!list[i].count) {
          openNotice('warning', `请设置「${list[i].name}」的购买数量。`);
          return ;
        }
        if (list[i].minPackageFlag === 'Y' && (list[i].count % list[i].minPackageQuantity)) {
          openNotice('warning', '购买数量必须是最小起订量的整数倍!');
          return;
        }
      }
      if (this.userData.second) {
        list = list.map(x => {
          let unitPrice = Math.ceil((x.price || x.originalPrice) * (100 - (x.priceRate || 0))) * 0.01;
          return {
            shoppingcartId: x.id,
            name: x.name, // 在后续页面被赋值给 productName
            code: x.itemNum || '', // 物料编码
            picUrl: x.picUrl,
            productId: x.productId,
            productCode: x.productCode,
            priceRate: x.priceRate || 0, // 下浮率
            unitPrice: unitPrice, // 实际单价，下浮价
            originalPrice: x.originalPrice || x.price,
            currentPrice: x.price,
            unit: x.unit,
            count: x.count,
            remark: x.remark || null,
            productType: 2, //
            sumPrice: unitPrice * x.count,
          };
        });
        window.sessionStorage.setItem('list_orders', JSON.stringify(list));
        hashHistory.push('/mallPay');
      } else {
        // 去生成订单页面
        // 精简字段
        list = list.map(x => ({
          id: x.id, // 在后续页面被赋值给 shoppingcartId
          name: x.name, // 在后续页面被赋值给 productName
          productId: x.productId,
          itemNum: x.productCode || '',
          proLine: x.proLine,
          productionCycle: x.productionCycle,
          originalPrice: x.originalPrice || x.showPrice,
          showPrice: x.showPrice,
          count: x.count,
          packageQuantity: x.packageQuantity,
          minPackageQuantity: x.minPackageQuantity,
          delvId: null, // 在后续页面赋值
          stockType: x.stockType,
          unit: x.unit,
          totalAmount: x.showPrice * x.count
        }));
        window.sessionStorage.setItem('list_orders', JSON.stringify(list));
        hashHistory.push('/shoppingCar/add/4');
      }
    } else {
      message.info('未选择商品');
    }
  }

  //关键字改变
  keywordChange(e) {
    this.setState({
      keyword: e.target.value,
    });
  }

  toGetMall() {
    if (this.state.keyword) {
      var newSearch = {
        ...this.store.state.searchMallData,
        keyword: this.state.keyword,
        p: 1,
        s: 10,
        orderField: 'view_count',
        orderString: 'desc',
      };
      productActions.searchChange(newSearch);
      hashHistory.push('/mallSearch');
    } else {
      message.info('请输入商品名称');
    }
  }

  notGo() {
    message.info('该产品已经下架');
  }

  render() {
    const { dataSource, selectedRowKeys, allProduct, orderLength } = this.state;
    const columns = [
      {
        title: '全选',
        dataIndex: 'all',
        key: 'all',
      }, {
        title: '',
        dataIndex: 'picUrl',
        key: 'picUrl',
        render: (text, record, index) => <div style={{ position: 'relative', width: '66px', height: '66px' }}>
          {
            record.active !== 'Active' &&
            <i style={{
              display: 'inline-block',
              position: 'absolute',
              top: '0',
              left: '0',
              width: '60px',
              height: '60px',
              borderRadius: '50%',
              textAlign: 'center',
              lineHeight: '54px',
              fontSize: '60px',
              color: '#fff',
              background: 'rgba(0, 0, 0, 0.6)',
            }} className="dmsIcon dmsDropOff"></i>
          }
          {
            record.active !== 'Active' ?
              <img onClick={this.notGo.bind(this)}
                   className='cart-img'
                   src={text ? `${config.server}${text}` : require('../../assets/images/product-default.png')}
                   alt="" />
              :
              <img
                onClick={() => this.goView(record.commodityId ? `/mallCommon/productDetail/${record.commodityId}/${record.productId}` : `/product/${record.productId}`)}
                className='cart-img'
                src={text ? `${config.server}${text}` : require('../../assets/images/product-default.png')}
                alt="" />
          }
        </div>,
      }, {
        title: '商品信息',
        dataIndex: 'name',
        key: 'name',
        render: (text, record, index) => {
          return <div>
            { // product/16030588
              record.active === 'Active' ?
                <p onClick={() => this.goView(record.commodityId ? `/mallCommon/productDetail/${record.commodityId}/${record.productId}` : `/product/${record.productId}`)}
                   className='pro-cart-title'>{record.name}</p>
                :
                <p onClick={this.notGo.bind(this)} className='pro-cart-title'>{record.name}</p>
            }
            <p style={{ color: '#777', fontSize: '12px', marginTop: '12px' }}>{record.specUnionKey}</p>
          </div>;
        },
      }, {
        title: '单价（元）',
        dataIndex: 'price',
        key: 'price',
        render: (text, record, index) => <span style={{ color: '#000' }}>{returnFloat(text)}</span>,
      }, {
        title: '数量',
        dataIndex: 'count',
        key: 'count',
        render: (text, record, index) => (
          <div>
            <InputNumber min={1} max={999999} defaultValue={record.count}
                         onChange={(val) => this.changeNumber(record, index, val)}
                         step={record.minPackageFlag === 'Y' && record.minPackageQuantity ? record.minPackageQuantity : 1} />
          </div>
        ),
      }, {
        title: '小计',
        dataIndex: 'totalAmount',
        key: 'totalAmount',
        render: (text, record, index) => <span
          style={{ color: '#d61518' }}>{returnFloat(text)}</span>,
      }, {
        title: '操作',
        key: 'action',
        render: (text, record, index) => (
          <div>
            <p onClick={() => this.deleteProduct(index, record.id)}
               style={{ color: '#000', fontSize: '14px', marginBottom: '12px', cursor: 'pointer' }}>
              <i style={{ marginRight: '10px' }} className='comIcon dmsBin'></i>
              <span>删除</span>
            </p>
            <p onClick={() => this.setCollection(record)}
               style={{ color: '#000', fontSize: '14px', cursor: 'pointer' }}>
              <i style={{ marginRight: '10px' }}
                 className={`comIcon ${record.isCollected == 1 ? 'dmsFullStar' : 'dmsStar'}`}></i>
              <span>{record.isCollected == 1 ? '取消收藏' : '加入收藏夹'}</span>
            </p>
          </div>
        ),
      },
    ];
    return <div>
      <Layout style={{ background: '#fff' }}>
        <Header id='mall-cart'>
          <div className="cart-word">购 物 车</div>
          <div className="mall-search">
						<input placeholder='请输入商品名称' onChange={this.keywordChange.bind(this)} type="text"
                   defaultValue={this.state.keyword} />
            <button onClick={this.toGetMall.bind(this)}>搜 索</button>
          </div>
          <div className="header-left" onClick={() => hashHistory.push('/mallHome')}>
            <i style={{ fontSize: '18px' }} className="dmsIcon dmsHome"></i>
            <span style={{ paddingLeft: '12px' }}>首页</span>
          </div>
          <div className="header-right">
            <div className='mall-nav' onClick={() => () => this.userData.second ? hashHistory.push('/thingsOrder') : hashHistory.push('/order')}>
              <i className='nav-word comIcon orderIcon'></i>
              {
                orderLength > 99 ?
                  <span className='nav-dot-more'>99<sup>+</sup></span>
                  :
                  <span className='nav-dot'>{orderLength}</span>
              }
            </div>
            {/*<div className='mall-nav'
             onClick={() => hashHistory.push('/mallCommon/userCenter/message')}>
             <i className='nav-word comIcon messageIcon'></i>
             {
             messageLength > 99 ?
             <span className='nav-dot-more'>99<sup>+</sup></span>
             :
             <span className='nav-dot'>{messageLength}</span>
             }
             </div>*/}
            <div className='mall-nav'
                 onClick={() => hashHistory.push('/mallCommon/userCenter/userInfo')}>
              <sapn className='nav-word comIcon userIcon'></sapn>
            </div>
          </div>
        </Header>
      </Layout>
      <div style={{ minHeight: this.state.mainHeight, background: '#fff' }} className="mall-table-box">
        <Table pagination={false}
               rowKey='id'
               rowSelection={{
                 selectedRowKeys,
                 type: 'checkbox',
                 onChange: this.onSelectChange,
               }}
               columns={columns}
               dataSource={dataSource}
               footer={() => (
                 <div className='cart-footer clear'>
                   <Checkbox
                     indeterminate={(selectedRowKeys.length > 0 && (selectedRowKeys.length !== dataSource.length)) ? true : false}
                     disabled={dataSource.length > 0 ? false : true}
                     onChange={this.checkBox}
                     checked={(selectedRowKeys.length > 0 && (selectedRowKeys.length == dataSource.length)) ? true : false}></Checkbox>
                   <span>全选</span>
                   <span onClick={this.deleteAll}>批量删除</span>
                   <button onClick={this.goPay.bind(this)}>去结算</button>
                   <div style={{
                     display: 'inline-block',
                     color: '#000',
                     marginRight: '30px',
                     float: 'right',
                   }}>
                     <p>合计：<span
                       style={{ color: '#d61518' }}>{this.state.allMoney}</span></p>
                     <p style={{ fontSize: '12px', marginTop: '12px' }}>
                       <span>总额：{this.state.total}</span>
                       {/*&emsp;
                        <span>立减 {returnFloat(this.state.allMinus)}</span>*/}
                     </p>
                   </div>
                   <p style={{ display: 'inline-block', color: '#777', float: 'right', marginRight: '50px' }}>
                     已选 <span
                     style={{ color: '#d61518' }}>{allProduct}</span> 件商品</p>
                 </div>
               )} />
      </div>
    </div>;
  }
}
;
export default withRouter(MallCart);



// WEBPACK FOOTER //
// ./src/mall/mallCart/index.js